(() => {
  'use strict';

  const money = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const formatMoney = (cents) => `US${money.format(Number(cents || 0) / 100)}`;
  const variantId = (id) => String(id || '').split('/').pop();
  const tomorrow = () => {
    const value = new Date();
    value.setDate(value.getDate() + 1);
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  document.querySelectorAll('[data-ct-short-tour]').forEach((root) => {
    const configNode = root.querySelector('[data-ct-short-tour-config]');
    const form = root.querySelector('[data-ct-short-form]');
    if (!configNode || !form) return;

    let tour;
    try {
      tour = JSON.parse(configNode.textContent);
    } catch (error) {
      return;
    }

    const date = form.querySelector('[name="tour_date"]');
    const groupSelect = form.querySelector('[name="group"]');
    const children = form.querySelector('[data-ct-short-children]');
    const confirm = form.querySelector('[data-ct-short-confirm]');
    const selection = form.querySelector('[data-ct-short-selection]');
    const feedback = form.querySelector('[data-ct-short-feedback]');
    const bookActions = form.querySelector('[data-ct-short-book-actions]');
    const quote = form.querySelector('[data-ct-short-quote]');
    const buttons = Array.from(form.querySelectorAll('[data-ct-short-add]'));
    let busy = false;

    date.min = tomorrow();

    const selectedGroup = () => {
      if (groupSelect.value === '') return null;
      return (tour.groups || [])[Number(groupSelect.value)] || null;
    };

    const quoteUrl = () => {
      const params = new URLSearchParams({
        source: 'short-tour',
        tour_id: String(tour.id || ''),
        tour: root.dataset.productTitle || ''
      });
      if (date.value) params.set('date', date.value);
      const group = selectedGroup();
      if (group) params.set('travellers', `${group.adults} adults`);
      if (children.checked) params.set('children', 'yes');
      return `${root.dataset.quoteUrl}?${params.toString()}`;
    };

    const setFeedback = (message) => {
      feedback.textContent = message;
    };

    const update = () => {
      const group = selectedGroup();
      const isQuote = children.checked;
      const validDate = Boolean(date.value) && date.value >= date.min;
      const canBook = !busy && !isQuote && Boolean(group) && validDate && confirm.checked;

      if (group) {
        const deposit = Math.round(Number(group.total_cents) * 0.2);
        selection.innerHTML = '';
        const total = document.createElement('strong');
        total.textContent = `${group.adults}-adult private party: ${formatMoney(group.total_cents)} total`;
        const detail = document.createElement('span');
        detail.textContent = `${formatMoney(group.per_person_cents)} per person - 20% deposit ${formatMoney(deposit)} - balance ${formatMoney(Number(group.total_cents) - deposit)}`;
        selection.append(total, detail);
      } else {
        selection.textContent = 'Select a group to see its exact private-party price.';
      }

      buttons.forEach((button) => { button.disabled = !canBook; });
      bookActions.hidden = isQuote;
      quote.href = quoteUrl();

      if (isQuote) {
        setFeedback('Trips including children are confirmed by our planning team. Continue with Request a quote.');
      } else if (!busy) {
        setFeedback('');
      }
    };

    const setBusy = (active, activeButton) => {
      busy = active;
      buttons.forEach((button) => {
        button.disabled = active || button.disabled;
        const label = button.querySelector('span');
        if (!label) return;
        if (!button.dataset.label) button.dataset.label = label.textContent;
        label.textContent = active && button === activeButton ? 'Adding to cart...' : button.dataset.label;
      });
      if (!active) update();
    };

    const validate = () => {
      if (!date.value || date.value < date.min) {
        date.setCustomValidity('Choose a date from tomorrow onward.');
        date.reportValidity();
        return false;
      }
      date.setCustomValidity('');
      if (!selectedGroup()) {
        groupSelect.setCustomValidity('Choose a valid adult group.');
        groupSelect.reportValidity();
        return false;
      }
      groupSelect.setCustomValidity('');
      if (!confirm.checked) {
        confirm.setCustomValidity('Confirm that ChinaTourly provided written date and price confirmation before payment.');
        confirm.reportValidity();
        return false;
      }
      confirm.setCustomValidity('');
      return true;
    };

    const addToCart = async (plan, button) => {
      if (busy || children.checked || !validate()) return;
      const group = selectedGroup();
      const total = Number(group.total_cents);
      const deposit = Math.round(total * 0.2);
      const isDeposit = plan === 'deposit';
      const id = variantId(isDeposit ? group.deposit_variant_id : group.full_variant_id);

      if (!/^\d+$/.test(id)) {
        setFeedback('This price option is not configured correctly. Please request a quote instead.');
        return;
      }

      setBusy(true, button);
      setFeedback('');
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id,
              quantity: 1,
              properties: {
                Date: date.value,
                Travellers: `${group.adults} adults`,
                'Payment plan': isDeposit ? '20% deposit' : 'Full payment',
                'Full trip total': formatMoney(total),
                'Balance due': formatMoney(isDeposit ? total - deposit : 0),
                _ct_short_tour: String(tour.id || tour.version || 'true')
              }
            }]
          })
        });

        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          throw new Error(body.description || body.message || 'The cart could not be updated.');
        }
        window.location.assign('/cart');
      } catch (error) {
        setBusy(false, button);
        setFeedback(error.message || 'The cart could not be updated. Please try again or request a quote.');
      }
    };

    groupSelect.addEventListener('change', () => {
      groupSelect.setCustomValidity('');
      update();
    });
    [date, children, confirm].forEach((input) => input.addEventListener('change', () => {
      input.setCustomValidity('');
      update();
    }));
    buttons.forEach((button) => button.addEventListener('click', () => addToCart(button.dataset.ctShortAdd, button)));
    update();
  });
})();
